export const toArray = any => {
  if (any === undefined || any === null) {
    return [];
  }

  return [].concat(any);
};

export default toArray;
